import { createRoutine } from 'redux-saga-routines'

export const getIncidentsRoutine = createRoutine('GET_INCIDENTS')
export const getIncidentStatsRoutine = createRoutine('GET_INCIDENT_STATS')
export const getIncidentRoutine = createRoutine('GET_INCIDENT')
export const generateSuggestionsRoutine = createRoutine('GENERATE_INCIDENT_SUGGESTIONS')
export const createIncidentRoutine = createRoutine('CREATE_INCIDENT')
export const closeIncidentRoutine = createRoutine('CLOSE_INCIDENT')
export const presignIncidentAttachmentRoutine = createRoutine('PRESIGN_INCIDENT_ATTACHMENT')
export const confirmIncidentAttachmentRoutine = createRoutine('CONFIRM_INCIDENT_ATTACHMENT')

export const CLEAR_INCIDENT_SUGGESTIONS = 'CLEAR_INCIDENT_SUGGESTIONS'
export const clearIncidentSuggestions = () => ({ type: CLEAR_INCIDENT_SUGGESTIONS })
